import React from 'react';

export const CheckMarkIcon = props => (
  <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" {...props}>
    <path fillRule="evenodd" d="M18.297 7l.703.682L10.26 17 5 12.793l.6-.777 4.566 3.652z" />
  </svg>
);
